import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const firebaseConf = {
  apiKey: publicRuntimeConfig.FIREBASE_API_KEY,
  authDomain: publicRuntimeConfig.FIREBASE_AUTH_DOMAIN,
  databaseURL: publicRuntimeConfig.FIREBASE_DATABASE_URL,
  projectId: publicRuntimeConfig.FIREBASE_PROJECT_ID,
  storageBucket: publicRuntimeConfig.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: publicRuntimeConfig.FIREBASE_MESSAGING_SENDER_ID,
  appId: publicRuntimeConfig.FIREBASE_APP_ID,
  measurementId: publicRuntimeConfig.FIREBASE_MEASUREMENT_ID,
};

export const initializeFirebase = () => {
  if (typeof window !== 'undefined' && window.firebase?.apps?.length) {
    return true;
  }
  return false;
};

export default typeof window !== 'undefined' ? window.firebase : null;
